<div class="web-gradient">
  <div class="container casestudies-body">
    <div class="row">
      <div class="col-md-7 py-5">
        <p class="text-white link-casestudy"><span (click)="nav('/')">Home</span> / <span (click)="nav('/kalpita-case-studies/case-study')">Case Studies</span></p>
        <h1 class="py-3 guard-head">
          100% web-based, ready to deploy & Easy-to-use alert-based cellular
          monitoring system
        </h1>
        <p class="py-3 guard-para">
          The client is a major player in cellular monitoring systems providing
          a powerful and intuitive interface that can act as an economical
          backup or expansion to traditional SCADA systems (Supervisory control
          and data acquisition).
        </p>
        <div class="service-box">
          <h6>Service:<span>Software Support </span></h6>
        </div>
      </div>
      <div class="col-md-5 guard-dog">
        <img
          src="../../../../assets/resources/casestudies/guard-dogimg.webp"
          class="img-fluid" alt="guard"
        />
      </div>
    </div>
  </div>
</div>
<!-- Problem objective section........................................................ -->
<div class="guardog-portalbg">
  <div class="container py-5">
    <div class="row">
      <div class="col-md-6">
        <h5 class="heading-guarddog py-3">The problem </h5>
        <p>
          They wanted to develop and scale a 100% web-based, ready to deploy
          monitoring system so users can manage their systems, easily view
          alarms, analyze trends for critical machinery and equipment.
        </p>
      </div>

      <div class="col-md-6">
        <h5 class="heading-guarddog py-3">Objective </h5>
        <p>
          We devised a system that could be set up and used in minutes. We made
          it as simple to use as possible while yet delivering best-in-class
          features and options.
        </p>
      </div>
    </div>
  </div>
</div>
<!-- The Solution....................................................................... -->
<div class="container">
  <div class="row">
    <div class="col-md-6 pt-5">
      <h5 class="heading-guarddog">The Solution</h5>
      <p class="py-4">
        We devised a system that could be set up and used in minutes. We made it
        as simple to use as possible while yet delivering best-in-class features
        and options.
      </p>
      <img
        src="../../../../assets/resources/casestudies/solutions/soluition-guardog.webp"
        alt="guardog-solution" class="img-fluid"
        width="100%"
      />
    </div>

    <div class="col-md-6">
      <div class="objective-background">
        <h5 class="text-white ps-3 py-5 solution-heading">Our Approach and Value add?</h5>
        <div class="objective-data ps-5 py-3">
          <ul>
            <li class="ico-img-sky">The system's initial setup is simple and quick.</li>
            <li class="ico-img-sky">
              Within minutes, consumers could generate graphs, analyze and
              export data, and much more.
            </li>
            <li class="ico-img-sky">
              Users were allowed to set flexible notification scheduling by day
              and time
            </li>
            <li class="ico-img-sky">Notifications via phone, email & text</li>
            <li class="ico-img-sky">Actionable and informative Graphing and Charting options</li>
            <li class="ico-img-sky">Interactive Mapping options</li>
            <li class="ico-img-sky">Alarm History Logs</li>
            <li class="ico-img-sky">Pump Data, Rainfall and Influent Reports</li>
            <li class="ico-img-sky">Exporting to PDF, and DOC</li>
          </ul>
        </div>
      </div>

      <div class="py-5">
        <p>
          To make sure timely alerts are received, we implemented changes in our
          callout plans by using multiple mediums of notifications.
        </p>
        <ul>
          <li>Text, call, or email notifications for regular alarms.</li>
          <li>
            three notification mediums for critical alarms (text, call, and
            email).
          </li>
        </ul>
      </div>

    </div>
  </div>
</div>
<!-- The Result.................................................................. -->
<div class="container">
  <div class="row py-3">
    <div class="col-md-12">
      <h5 class="heading-guarddog">The Result</h5>
      <ul>
        <li class="ico-img">Equipped monitoring pumps so the sewage is not dumped into creeks & rivers.</li>
        <li class="ico-img">Customers are given timely alerts in the event of flooding.</li>
        <li class="ico-img">Telemetry and scoring tools with web</li>
        <li class="ico-img">Insightful mobile apps</li>
      </ul>
    </div>
  </div>
</div>
<!-- Technologies used......................................................... -->
<div class="container">
  <div class="row py-4">
    <div class="col-md-8">
      <h5 class="heading-guarddog py-3">Technologies used</h5>
      <div class="row">
        <div class="col-md-1"></div>
      <div class="col-md-2 col-6 py-2">
       <img src="../../../../assets/resources/casestudies/icons/dotnet-tech.png" class="img-fluid tech-icon" alt="techone"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/aws-tech.png" class="img-fluid tech-icon" alt="techtwo"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/micro-azure.png" class="img-fluid tech-icon" alt="techthree"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/aspdot-net.png" class="img-fluid tech-icon" alt="techfour"/>
      </div>
      <div class="col-md-2 col-6 py-2">
        <img src="../../../../assets/resources/casestudies/icons/react-tech.png" class="img-fluid tech-icon" alt="techfive"/>
      </div>
    </div>
    </div>
      <div class="col-md-4">

      </div>
  </div>
</div>
